import { render, staticRenderFns } from "./VirtualPwdInputEdit.vue?vue&type=template&id=23a494a1&scoped=true&"
import script from "./VirtualPwdInputEdit.vue?vue&type=script&lang=js&"
export * from "./VirtualPwdInputEdit.vue?vue&type=script&lang=js&"
import style0 from "./VirtualPwdInputEdit.vue?vue&type=style&index=0&id=23a494a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a494a1",
  null
  
)

export default component.exports